import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  Button, 
  Typography, 
  Container, 
  Paper, 
  Alert,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { login, error, isAuthenticated, loading, shouldForceLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // If already authenticated, redirect to intended location or dashboard
  useEffect(() => {
    if (isAuthenticated) {
      // Priority order: returnTo -> from state -> lastRoute -> dashboard
      const returnTo = localStorage.getItem('returnTo');
      const lastRoute = localStorage.getItem('lastRoute');
      const from = location.state?.from?.pathname;
      
      if (returnTo && returnTo !== '/login') {
        localStorage.removeItem('returnTo');
        navigate(returnTo);
      } else if (from && from !== '/login') {
        navigate(from);
      } else if (lastRoute && lastRoute !== '/login' && lastRoute !== '/' && lastRoute !== '/home') {
        // Only use lastRoute if it's not the home page (to allow fresh dashboard visits)
        navigate(lastRoute);
      } else {
        navigate('/app');
      }
    }
  }, [isAuthenticated, navigate, location]);

  // Handle login button click
  const handleLogin = () => {
    login();
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" sx={{ mb: 3, fontWeight: 'bold' }}>
            AustnewsCRM
          </Typography>
          <Typography component="h2" variant="h5" align="center" sx={{ mb: 3 }}>
            Sign In
          </Typography>
          
          {shouldForceLogin && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Your session has expired. Please sign in again to continue.
            </Alert>
          )}
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Sign In with Auth0'}
          </Button>
          
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Secure authentication powered by Auth0
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Login; 
